import constant from "../../constant";
import router from "../../router";
const api = constant.api + "societies";
// initial state
const state = () => ({
  all: [],
  societies: [],
  society: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getSociety: (state) => {
    return state.society;
  },

  getSocieties: (state) => {
    return state.societies;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    await this.$api.show(api).then((response) => {
      let societies = response.data;
      commit("setSocieties", societies);
    });
  },
  async fetchSocieties({ commit }) {
    await this.$api.show(api).then((response) => {
      let societies = response.data;
      commit("setSocieties", societies);
    });
  },
  async show({ commit }, reference) {
    await this.$api.show(api + "/" + reference).then((response) => {
      let society = response.data;
      commit("setSociety", society);
    });
  },

  async store({ commit, dispatch }, data) {
    await this.$api.create(api, data, { 
      confirm: false,
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") router.push({ name: "societies-index" });
    });
  },

  async update({ dispatch }, data) {
    console.log(data);
    await this.$api.update(api + "/" + data.reference, data.formData, { confirm: false }).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });

      if (status == "success") {
        router.push({
          name: "societies-index",
        });
      }
    });
  },

  async destroy({ commit, dispatch }, reference) {
    await this.$api.delete(api + "/" + reference, { confirm: false }).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      let societies = response.data.data;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") commit("setSocieties", societies);
    });
  },
};

// mutations
const mutations = {
  setSocieties(state, societies) {
    state.all = societies;
    state.societies = societies;
  },
  setSociety(state, society) {
    state.society = society;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
